var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-form',{ref:"Form",attrs:{"show-legend":""}},[_c('CidadaoQuestionarioSaude',{attrs:{"form":_vm.form,"model":_vm.model}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }